import { digObject } from '@domain-group/javascript-utils'

import { useNotificationBanner } from '@domain-group/react-hooks'

import {
  NotificationBannerLocation as NotificationBannerLocationBase,
} from '@domain-group/suit-theme'

import useNotifications from '@hooks/useNotifications'
import useCurrentUser from '@hooks/useCurrentUser'
import locationOptions from '@functions/notification'

type NotificationBannerLocationProps = {
  boxProps?: object,
  locationKey: string,
}

const NotificationBannerLocation = (props: NotificationBannerLocationProps) => {
  const { locationKey, boxProps = {} } = props

  const { currentUser: { id: userId } } = useCurrentUser()

  const { filteredNotifications } = useNotifications({
    filters: {
      active: 'true',
      location: 'targeted',
      realhub_platform: 'standalone_v1',
      targetLocation: locationKey,
    },
    performHttpRequests: !!locationKey,
    requestOptions: {
      include_notification_image: true,
      include_attachment_file: true,
      limit: locationOptions.length,
    },
  })

  const lastIndex = filteredNotifications.length ? filteredNotifications.length - 1 : 0
  const notification = filteredNotifications[lastIndex] || {}

  // @ts-expect-error TS2322
  const useNotificationBannerPayload = useNotificationBanner({ userId, notification })
  const {
    callbacks: { dismissNotification },
    isDismissed,
    seenNotifications,
  } = useNotificationBannerPayload

  const dismissable = digObject(notification, 'options.dismissable')
  const isDismissable = !!dismissable

  const location = digObject(notification, 'options.location')
  const isSidebar = location?.includes('sidebar')

  if (!notification.id || seenNotifications.includes(notification.id) || isDismissed){
    return null
  }

  return (
    <NotificationBannerLocationBase
      boxProps={boxProps}
      callbacks={{ dismissNotification }}
      isDismissable={isDismissable}
      isSidebar={isSidebar}
      notification={notification}
      target="_blank"
    />
  )
}

export default NotificationBannerLocation
